import { UserResolve } from './user/user.resolve';
import { GiftsResolve } from './registry/gifts.resolve';
import { UserLoggedInResolve } from './user/user-logged-in.resolve';
import { ImageUrlService } from './shared/services/image-url.service';

import { environment } from './../environments/environment';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AppLoadedState } from './app.loaded.state';
import { AppRouterState } from './app.router.state';
import { PathGuard } from './guards/path.guard';
import { AuthService } from './user/auth.service';
import { RegistryFirebaseService } from './registry/registry-firebase.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegistryModule } from './registry/registry.module';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import * as Raven from 'raven-js';
import { appRoutes } from './app.routing';
import { AppComponent } from './app.component';
import { PageNotFound404Component } from './404/404.component';
import { FirestoreService } from './shared/firebase.service';
import { RegistryService } from './registry/registry.service';
import { SigninComponent } from './signin/signin.component';
import { RegistryResolve } from './registry/registry.resolve';
import { SignupComponent } from './signup/signup.component';
import { StripeGuideComponent } from './stripe-guide/stripe-guide.component';
import { IntercomModule } from 'ng-intercom';
import { ContributionsResolve } from './registry/contributions.resolve';
import { SettingsResolve } from './registry/settings.resolve';
import { WebsiteResolve } from './website/website.resolve';
import { GuestsResolve } from './guest-list/guests.resolve';
import { RouteReuseStrategy } from '@angular/router';
import { CustomReuseStrategy } from './registry/custom-reuse-strategy';
import { MerchantResolve } from './merchant/merchant.resolve';
import { PayEngineService } from './services/payengine.service';

if (environment.sentryId) {
  Raven
    .config(environment.sentryId)
    .install();

}

export class RavenErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    console.error(err);
    if (environment.sentryId) {
      Raven.captureException(err);
    }
  }
}

@NgModule({
  declarations: [
    AppComponent,
    PageNotFound404Component,
    SigninComponent,
    SignupComponent,
    StripeGuideComponent,
    ForgotPasswordComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    appRoutes,
    ReactiveFormsModule,

    RegistryModule,
    IntercomModule.forRoot({

      appId: environment.intercomApiKey,
      updateOnRouterChange: true, // will automatically run `update` on router event changes. Default: `false`

    }), // imports firebase/app needed for everything
    AngularFireModule.initializeApp(environment.firebase, 'my-app-name'),
    AngularFirestoreModule, // imports firebase/firestore, only needed for database features
    AngularFireAuthModule // imports firebase/auth, only needed for auth features

  ],
  providers: [
    FirestoreService,
    RegistryFirebaseService,
    RegistryService,
    AuthService,
    ImageUrlService,
    AppRouterState,
    AppLoadedState,
    RegistryResolve,
    UserLoggedInResolve,
    UserResolve,
    GiftsResolve,
    ContributionsResolve,
    GuestsResolve,
    SettingsResolve,
    MerchantResolve,
    WebsiteResolve,
    //   CartService,
    { provide: ErrorHandler, useClass: RavenErrorHandler },
    //   CustomValidatorsService,
    //   HttpService,
    //   AuthGuard,
    //   SettingsService,
    //   PaymentService,
    //   UserService
    PathGuard,
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    PayEngineService

  ],

  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts